export const normalizeShareData = (data, shareData) => {
  const cat = data.categories.find(c => c.name === shareData?.meta.category);

  return {
    campaign: {
      name: data.title,
      url: data.url,
      image: data.meta.image,
    },
    category: {
      name: cat.name,
      url: cat.meta.url,
      image: cat.meta.image,
    },
    destination: {
      name: shareData.name,
      url: `${data.url}#${shareData.name.toLowerCase()}`,
      image: shareData.media.find(m => m.type === "image")?.src,
    },
  };
};
